import React from 'react'
import { 
    Tooltip,IconButton
    } from '@mui/material';

import GetAppIcon from '@mui/icons-material/GetApp';



const ExportButton = ({...props}) => {

    const { handleExport, formId, packageId, userId} = props;

    return (
        <Tooltip title="Export" onClick={e => handleExport(e, formId, packageId, userId)}>
            <IconButton aria-label="export" size="large">
                <GetAppIcon />
            </IconButton>
        </Tooltip>
    );
}

export default ExportButton;